<script>
import DashboardLayout from '../components/customDashboards/DashboardLayout.vue';
import { mapGetters } from 'vuex';
import customDashboardsMixin from 'shared/mixins/customDashboardsMixin';
import Spinner from 'shared/components/Spinner.vue';
import { useAlert } from 'dashboard/composables';

export default {
  name: 'CustomDashboards',
  components: {
    DashboardLayout,
    Spinner,
  },
  mixins: [customDashboardsMixin],
  props: {},
  data() {
    return {
      widgets: [],
      showDeleteModal: false,
      lastUpdatedTime: this.generateCurrentDate(),
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'customDashboards/getUIFlags',
    }),
    dashboardId() {
      return Number(this.$route.params.dashboardId);
    },
    currentDashboard() {
      return (
        this.customDashboards.find(
          dashboard => dashboard.id === this.dashboardId
        ) || {}
      );
    },
    layoutMetrics() {
      let metrics = this.currentDashboard.settings?.layout?.metrics || [];
      if (metrics && metrics.length > 0) {
        metrics.map(widget => {
          if (widget.contentProps.display.type === 'static_image') {
            widget.contentProps.imageLinkContent =
              this.imgUrlForStaticImageDisplay;
          }
          return widget;
        });
      }
      return metrics || [];
    },
    imgUrlForStaticImageDisplay() {
      return this.currentDashboard.img_url || '';
    },
  },
  watch: {
    dashboardId() {
      this.lastUpdatedTime = this.generateCurrentDate();
    },
  },
  created() {},
  methods: {
    editDashboard() {
      // LÓGICA PARA EDIÇÃO DO DASHBOARD AQUI
      const path = this.dashboardId + '/edit';
      this.redirectToDashboardPage(path);
    },
    async confirmDeletion() {
      this.showDeleteModal = false;
      try {
        await this.$store.dispatch('customDashboards/delete', this.dashboardId);
        useAlert(
          this.$t('CUSTOM_DASHBOARDS.DELETE_DASHBOARD.API.SUCCESS_MESSAGE')
        );
        this.fetchCurrentCustomDashboards();
        this.redirectToDashboardPage();
      } catch (e) {
        useAlert(
          this.$t('CUSTOM_DASHBOARDS.DELETE_DASHBOARD.API.ERROR_MESSAGE')
        );
      }
    },
    generateCurrentDate() {
      let currentLanguage = this.$root.$i18n.locale.trim();
      if (currentLanguage === 'pt_BR') currentLanguage = 'pt-BR';
      else if (currentLanguage === 'es') currentLanguage = 'es-ES';
      else if (!['es', 'en'].includes(currentLanguage)) currentLanguage = 'en';

      const date = new Date().toLocaleDateString(currentLanguage, {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      });
      const hour = new Date().toLocaleTimeString(currentLanguage, {
        hour: '2-digit',
        minute: '2-digit',
      });
      return `${date} - ${hour}`;
    },
  },
};
</script>

<template>
  <Spinner v-if="uiFlags.isFetching" />

  <span
    v-else-if="!currentDashboard.title"
    class="text-red-400 dark:text-red-500 text-sm block font-normal -mt-px w-full"
  >
    {{ $t('CUSTOM_DASHBOARDS.DISPLAY_DASHBOARD.ERROR') }}
  </span>

  <div v-else class="p-4 pt-0">
    <!-- START DASHBOARD SECTION -->
    <div class="pt-5">
      <h5 class="text-3xl mb-2 font-bold">
        {{ currentDashboard.title }}
      </h5>
      <label class="text-xs">
        {{
          $t('CUSTOM_DASHBOARDS.DISPLAY_DASHBOARD.LAST_UPDATED_AT') +
          lastUpdatedTime
        }}
      </label>
      <div class="mx-0 rounded-[4px]">
        <DashboardLayout
          :metrics-from-a-p-i="layoutMetrics"
          :edit-mode="false"
        />
      </div>
    </div>
    <!-- END DASHBOARD SECTION -->
    <div class="pt-4">
      <hr />
      <div class="flex gap-4">
        <!-- START DESCRIPTION SECTION -->
        <div class="w-full">
          <p class="text-xs mb-2 font-bold">
            {{ $t('CUSTOM_DASHBOARDS.DISPLAY_DASHBOARD.DESCRIPTION') }}
          </p>
          <p class="font-medium">
            {{ currentDashboard.description || '-' }}
          </p>
        </div>
        <!-- END DESCRIPTION SECTION -->
        <div class="flex">
          <!-- START EDIT DASHBOARD BUTTON SECTION -->
          <div class="pr-2">
            <woot-button
              color-scheme="success"
              icon="edit"
              @click="editDashboard"
            >
              {{ $t('CUSTOM_DASHBOARDS.DISPLAY_DASHBOARD.EDIT_BUTTON') }}
            </woot-button>
          </div>
          <!-- END EDIT DASHBOARD BUTTON SECTION -->

          <!-- START DELETE DASHBOARD BUTTON SECTION -->
          <div class="pr-2">
            <woot-button
              v-tooltip.left="
                $t('CUSTOM_DASHBOARDS.DISPLAY_DASHBOARD.DELETE_BUTTON')
              "
              color-scheme="alert"
              icon="delete"
              :is-loading="uiFlags.isDeleting"
              @click="showDeleteModal = true"
            />
          </div>
          <!-- END DELETE DASHBOARD BUTTON SECTION -->
        </div>
      </div>
    </div>

    <woot-delete-modal
      v-if="showDeleteModal"
      v-model:show="showDeleteModal"
      :on-close="() => (showDeleteModal = false)"
      :on-confirm="confirmDeletion"
      :title="$t('CUSTOM_DASHBOARDS.DELETE_DASHBOARD.TITLE')"
      :message="$t('CUSTOM_DASHBOARDS.DELETE_DASHBOARD.MESSAGE')"
      :confirm-text="$t('CUSTOM_DASHBOARDS.DELETE_DASHBOARD.DELETE')"
      :reject-text="$t('CUSTOM_DASHBOARDS.DELETE_DASHBOARD.CANCEL')"
    />
  </div>
</template>
